/* eslint-disable no-fallthrough */
/* eslint-disable no-console */
import { generalConfigurationActionTypes } from '../../actions/configurations/generalConfigurationActions';

const GeneralConfigurationReducers = (state = {}, action) => {
  switch (action.type) {
    case generalConfigurationActionTypes.GET_GENERAL_CONFIGURATION.LOADING: {
      const { getGeneralConfigurationLoading, entityType } = action;

      if (entityType === 'PRODUCTS') {
        return {
          ...state,
          getGeneralConfigurationProductsLoading: getGeneralConfigurationLoading,
        };
      }
      if (entityType === 'VENDORS') {
        return {
          ...state,
          getGeneralConfigurationVendorsLoading: getGeneralConfigurationLoading,
        };
      }
      if (entityType === 'CUSTOMERS') {
        return {
          ...state,
          getGeneralConfigurationCustomersLoading: getGeneralConfigurationLoading,
        };
      }

      if (entityType === 'GOOD_RECEIVING_NOTE') {
        return {
          ...state,
          getGeneralConfigurationGoodReceivingNotesLoading: getGeneralConfigurationLoading,
        };
      }
      if (entityType === 'PURCHASE_ORDER') {
        return {
          ...state,
          getGeneralConfigurationPurchaseOrdersLoading: getGeneralConfigurationLoading,
        };
      }
      if (entityType === 'PURCHASE_REQUEST') {
        return {
          ...state,
          getGeneralConfigurationPurchaseRequestLoading: getGeneralConfigurationLoading,
        };
      }
      if (entityType === 'DEBIT_NOTE') {
        return {
          ...state,
          getGeneralConfigurationDebitNoteLoading: getGeneralConfigurationLoading,
        }
      }
      if (entityType === 'CREDIT_NOTE') {
        return {
          ...state,
          getGeneralConfigurationCreditNoteLoading: getGeneralConfigurationLoading,
        };
      }
      if (entityType === 'RETURN_SLIP') {
        return {
          ...state,
          getGeneralConfigurationReturnSlipLoading: getGeneralConfigurationLoading,
        };
      }
      if (entityType === 'INVOICE') {
        return {
          ...state,
          getGeneralConfigurationInvoiceLoading: getGeneralConfigurationLoading,
        };
      }
      if (entityType === 'MANUFACTURING_ORDER') {
        return {
          ...state,
          getGeneralConfigurationManufacturingOrderLoading: getGeneralConfigurationLoading,
        };
      }
      if (entityType === 'SALES_ESTIMATE') {
        return {
          ...state,
          getGeneralConfigurationSalesEstimateLoading: getGeneralConfigurationLoading,
        };
      }
      if (entityType === 'SALES_ORDER') {
        return {
          ...state,
          getGeneralConfigurationSalesOrderLoading: getGeneralConfigurationLoading,
        };
      }
      if (entityType === 'PACKING_SLIP') {
        return {
          ...state,
          getGeneralConfigurationPackingSlipLoading: getGeneralConfigurationLoading,
        };
      }
      if (entityType === 'ANNUAL_MAINTENANCE_CONTRACT') {
        return {
          ...state,
          getGeneralConfigurationAnnualMaintenanceContractLoading: getGeneralConfigurationLoading,
        };
      }
      if (entityType === 'ACCOUNT_PAYABLE_INVOICE') {
        return {
          ...state,
          generalConfigurationAPInvoiceLoading: getGeneralConfigurationLoading,
        };
      }
      if (entityType === 'STOCK_TRANSFER') {
        return {
          ...state,
          getGeneralConfigurationStockTransferLoading: getGeneralConfigurationLoading,
        };
      }
    }

    case generalConfigurationActionTypes.GET_GENERAL_CONFIGURATION.SUCCESS: {
      const { getGeneralConfiguration, entityType } = action;

      if (entityType === 'PRODUCTS') {
        return {
          ...state,
          generalConfigurationProducts: getGeneralConfiguration,
        };
      }
      if (entityType === 'VENDORS') {
        return {
          ...state,
          generalConfigurationVendors: getGeneralConfiguration,
        };
      }
      if (entityType === 'CUSTOMERS') {
        return {
          ...state,
          generalConfigurationCustomers: getGeneralConfiguration,
        };
      }
      if (entityType === 'GOOD_RECEIVING_NOTE') {
        return {
          ...state,
          generalConfigurationGoodReceivingNotes: getGeneralConfiguration,
        };
      }
      if (entityType === 'PURCHASE_ORDER') {
        return {
          ...state,
          generalConfigurationPurchaseOrders: getGeneralConfiguration,
        };
      }
      if (entityType === 'PURCHASE_REQUEST') {
        return {
          ...state,
          generalConfigurationPurchaseRequest: getGeneralConfiguration,
        };
      }
      if (entityType === 'DEBIT_NOTE') {
        return {
          ...state,
          generalConfigurationDebitNote: getGeneralConfiguration,
        }
      }
      if (entityType === 'CREDIT_NOTE') {
        return {
          ...state,
          generalConfigurationCreditNote: getGeneralConfiguration,
        };
      }
      if (entityType === 'RETURN_SLIP') {
        return {
          ...state,
          generalConfigurationReturnSlip: getGeneralConfiguration,
        };
      }
      if (entityType === 'INVOICE') {
        return {
          ...state,
          generalConfigurationInvoice: getGeneralConfiguration,
        };
      }
      if (entityType === 'MANUFACTURING_ORDER') {
        return {
          ...state,
          generalConfigurationManufacturingOrder: getGeneralConfiguration,
        };
      }
      if (entityType === 'SALES_ESTIMATE') {
        return {
          ...state,
          generalConfigurationSalesEstimate: getGeneralConfiguration,
        };
      }
      if (entityType === 'SALES_ORDER') {
        return {
          ...state,
          generalConfigurationSalesOrder: getGeneralConfiguration,
        };
      }
      if (entityType === 'PACKING_SLIP') {
        return {
          ...state,
          generalConfigurationPackingSlip: getGeneralConfiguration,
        };
      }
      if (entityType === 'ANNUAL_MAINTENANCE_CONTRACT') {
        return {
          ...state,
          generalConfigurationAnnualMaintenanceContract: getGeneralConfiguration,
        };
      }
      if (entityType === 'ACCOUNT_PAYABLE_INVOICE') {
        return {
          ...state,
          generalConfigurationAPInvoice: getGeneralConfiguration,
        };
      }
      if (entityType === 'STOCK_TRANSFER') {
        return {
          ...state,
          generalConfigurationStockTransfer: getGeneralConfiguration,
        };
      }
    }

    case generalConfigurationActionTypes.UPDATE_GENERAL_CONFIGURATION.LOADING: {
      const { updateGeneralConfigurationLoading } = action;
      return {
        ...state,
        updateGeneralConfigurationLoading,
      };
    }
    default: {
      return state;
    }
  }
};

export default GeneralConfigurationReducers;
